import * as React from 'react';
import { format, isDate } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Tip } from './Tip';
import { invertBandScale } from '../../TrackArea/utils';
var defaultTimeFormat = 'd MMM HH:mm';
export function Tooltip(_a) {
    var data = _a.data, mouseX = _a.mouseX, xScale = _a.xScale, accessors = _a.accessors, meta = _a.meta, colorScheme = _a.colorScheme;
    if (mouseX === undefined)
        return null;
    var time = typeof xScale.invert === 'function'
        ? xScale.invert(mouseX)
        : invertBandScale(xScale, mouseX);
    var vals = data
        .map(function (_a) {
        var _b, _c, _d, _e, _f, _g;
        var datum = _a.datum, series = _a.series;
        // TODO
        // eslint-disable-next-line array-callback-return
        if (datum === undefined)
            return;
        return {
            type: (_c = (_b = accessors === null || accessors === void 0 ? void 0 : accessors.type) === null || _b === void 0 ? void 0 : _b.call(accessors, series)) !== null && _c !== void 0 ? _c : 'number',
            name: accessors.name(series),
            unit: (_e = (_d = accessors === null || accessors === void 0 ? void 0 : accessors.unit) === null || _d === void 0 ? void 0 : _d.call(accessors, series)) !== null && _e !== void 0 ? _e : '',
            unitSymbol: (_g = (_f = accessors === null || accessors === void 0 ? void 0 : accessors.unitSymbol) === null || _f === void 0 ? void 0 : _f.call(accessors, series)) !== null && _g !== void 0 ? _g : '',
            xVal: accessors.x(datum),
            yVal: accessors.y(datum),
            key: accessors.key(series)
        };
    })
        .filter(function (val) { return val !== undefined; });
    if (vals.length === 0)
        return null;
    var m = meta !== null && meta !== void 0 ? meta : {};
    var _b = m.timeFormat, timeFormat = _b === void 0 ? defaultTimeFormat : _b, headLabel = m.headLabel, timezone = m.timezone;
    var timeLabel = isDate(time) && timezone !== undefined
        ? format(utcToZonedTime(time, timezone), timeFormat)
        : format(time, timeFormat);
    return (React.createElement(Tip, { time: timeLabel, vals: vals, colorScheme: colorScheme, headLabel: headLabel }));
}
//# sourceMappingURL=Tooltip.js.map